import { ApiService } from "../ApiService";
import {
  ItemGroup,
  CreateItemGroupRequest,
  UpdateItemGroupRequest,
  GetItemGroupByIdRequest,
  GetItemGroupByNameRequest,
  DeleteItemGroupRequest,
  BulkDeleteItemGroupRequest,
} from "../../Types/Admin/AdminProductGroupType";
import { ResultsDTO } from "Types/ResultsDTO";
export { useGetAllItemGroupsQuery } from "./ItemGroupApi";

export const ProductGroupAdminApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    createItemGroup: builder.mutation<ResultsDTO, CreateItemGroupRequest>({
      query: (body) => ({
        url: "/ItemGroups/create",
        method: "POST",
        params: { plant: body.plant },
        body,
      }),
      invalidatesTags: ["ItemGroup"],
    }),

    getItemGroupById: builder.query<ItemGroup, GetItemGroupByIdRequest>({
      query: ({ id, plant }) => ({
        url: "/ItemGroups/getById",
        method: "GET",
        params: { id, plant },
      }),
      transformResponse: (res: ResultsDTO<ItemGroup>) => res.results,
      providesTags: ["ItemGroup"],
    }),

    getItemGroupByName: builder.query<ItemGroup, GetItemGroupByNameRequest>({
      query: ({ itemGrp, plant }) => ({
        url: "/ItemGroups/getByItemGrpName",
        method: "GET",
        params: { itemGrp, plant },
      }),
      transformResponse: (res: ResultsDTO<ItemGroup>) => res.results,
      providesTags: ["ItemGroup"],
    }),

    updateItemGroup: builder.mutation<ResultsDTO, UpdateItemGroupRequest>({
      query: (body) => ({
        url: "/ItemGroups/update",
        method: "PUT",
        params: { plant: body.plant },
        body,
      }),
      invalidatesTags: ["ItemGroup"],
    }),

    deleteItemGroup: builder.mutation<ResultsDTO, DeleteItemGroupRequest>({
      query: ({ id, plant }) => ({
        url: "/ItemGroups/delete",
        method: "DELETE",
        params: { id, plant },
      }),
      invalidatesTags: ["ItemGroup"],
    }),

    deleteItemGroupsBulk: builder.mutation<ResultsDTO, BulkDeleteItemGroupRequest>({
      query: ({ ids, plant }) => ({
        url: "/ItemGroups/bulk-delete",
        method: "DELETE",
        params: {
          ids,
          plant,
        },
      }),
      invalidatesTags: ["ItemGroup"],
    }),
  }),
});

export const {
  useCreateItemGroupMutation,
  useGetItemGroupByIdQuery,
  useGetItemGroupByNameQuery,
  useUpdateItemGroupMutation,
  useDeleteItemGroupMutation,
  useDeleteItemGroupsBulkMutation,
} = ProductGroupAdminApiSlice;
